export default "__VITE_ASSET__Bo_E96g3__"